import React, { memo } from 'react'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid2'
import { FormattedMessage, useIntl } from 'react-intl'
import Typography from '@mui/material/Typography'
import Image from 'next/image'
import sx from './styles'

const NecessaryDocuments = ({ handleRedirectToHome }) => {
  const { formatMessage: f } = useIntl()

  return (
    <Grid container>
      <Grid
        size={12}
        my={2}
      >
        <Typography
          variant="subtitle2"
        >
          {f({ id: 'EASY_FORM_SUBTITLE_FEEDBACK' })}
        </Typography>
      </Grid>

      <Image
        title={f({ id: 'EASY_MAIN_TITLE' })}
        src="https://clikauto-network.mystagingwebsite.com/clikauto-staging/wp-content/uploads/sites/3/2023/01/Infografia-Documentos_para_ayudar_a_vender_.png"
        alt={f({ id: 'EASY_MAIN_TITLE' })}
        width={500}
        height={650}
        priority
      />

      <Grid
        size={12}
        mt={2}
      >
        <Button
          sx={sx.cta}
          id="button-go-to-home"
          fullWidth
          variant="contained"
          onClick={handleRedirectToHome}
        >
          <FormattedMessage id="KNOW_CLIKAUTO" />
        </Button>
      </Grid>

    </Grid>
  )
}

export default memo(NecessaryDocuments)
